import { MouseEventHandler, ReactNode } from "react";
import Image from "../Primitive/Image"
import { Badge } from "@chakra-ui/react"

function UserCard(props: {
    userCardStyle?: string
    leftPanelStyle?: string
    middlePanelStyle?: string
    rightPanelStyle?: string
    textStyleContainer?: string
    textStyle?: string
    textStyleMore25?: string
    subtextStyle?: string
    subtextStyleContainer?: string
    rightTextStyle?: string
    profileImageStyle?: string
    leftPanelItem?: string | React.JSX.Element | ReactNode[]
    leftPanelItemStyle?: string
    imageSrc?: string
    text?: string | ReactNode[] | React.JSX.Element
    subtext?: string | ReactNode[] | React.JSX.Element
    rightText?: string | ReactNode[] | React.JSX.Element | null
    badge?: string | ReactNode[] | React.JSX.Element
    onClick?: () => void | MouseEventHandler<HTMLDivElement>
    onLeftItemClick?: () => void
    onMiddleItemClick?: () => void
    onRightItemClick?: () => void
    onTextClick?: () => void
}) {
    const onTouchTap = (event: React.TouchEvent<HTMLElement>, callback?: () => void) => {
        event.preventDefault()
        event.stopPropagation()
        callback?.()
    }

    const createTouchHandler = (callback?: () => void) => {
        if (!callback) {
            return undefined
        }

        return (event: React.TouchEvent<HTMLElement>) => onTouchTap(event, callback)
    }

    return (
        <div
            onClick={props.onClick as any}
            onTouchEnd={createTouchHandler(typeof props.onClick === "function" ? (props.onClick as any) : undefined)}
            className={props.userCardStyle}
        >
            <div
                className={`${props.userCardStyle}__${props.leftPanelStyle}`}
                onClick={props.onLeftItemClick}
                onTouchEnd={createTouchHandler(props.onLeftItemClick)}
            >
                {props.leftPanelItem}
                <Image src={props.imageSrc} className={`${props.userCardStyle}__${props.profileImageStyle}`} />
            </div>
            <div
                className={`${props.userCardStyle}__${props.middlePanelStyle}`}
                onClick={props.onMiddleItemClick}
                onTouchEnd={createTouchHandler(props.onMiddleItemClick)}
            >
                <div className={`${props.userCardStyle}__${props.textStyleContainer}`}>
                    <div
                        onClick={props.onTextClick}
                        onTouchEnd={createTouchHandler(props.onTextClick)}
                        className={`${props.userCardStyle}__${  
                            props.text && typeof props.text === "string" && props.text.length < 25 ? props.textStyle : props.textStyleMore25
                        }`}
                    >
                        {props.text}
                        {props.badge && props.badge === 'Moderator:in' && (
                            <>
                            <br />
                            <Badge className={`${props.userCardStyle}__badge ${props.userCardStyle}__badge--moderator`}>{props.badge}</Badge>
                            </>
                            
                        )}
                        
                        {props.badge && props.badge === 'Mitglied' && (
                            <>
                            <br />
                            <Badge className={`${props.userCardStyle}__badge ${props.userCardStyle}__badge--member`}>{props.badge}</Badge>
                            </>
                        )}
                    </div>
                </div>
                <div className={`${props.userCardStyle}__${props.subtextStyleContainer}`}>
                    <div className={`${props.userCardStyle}__${props.subtextStyle}`}> {props.subtext} </div>
                </div>
            </div>
            <div className={`${props.userCardStyle}__${props.rightPanelStyle}`}>
                {props.rightTextStyle ? (
                    <div
                        onClick={props.onRightItemClick}
                        onTouchEnd={createTouchHandler(props.onRightItemClick)}
                        className={`${props.userCardStyle}__${props.rightTextStyle}`}
                    >
                    {props.rightText}
                </div>
                ) : (
                    props.rightText
                )}
                
            </div>
        </div>
    )
}
export default UserCard
